import * as React from 'react';
import { CheckboxInline } from '@common/components';

interface SelectCountProperties {
  readonly selectedCount: number;
  readonly total: number;
  readonly onChange: Function;
  readonly readonly?: boolean;
}

/**
 * Component for displaying selected quantity
 *
 * @class SelectCount
 * @extends {React.Component<SelectCountProperties>}
 */
export class SelectCount extends React.Component<SelectCountProperties> {
  /**
   * Only re-render if count changes
   *
   * @param {SelectCountProperties} nextProps
   * @returns
   * @memberof SelectCount
   */
  shouldComponentUpdate(nextProps: SelectCountProperties) {
    return this.props.selectedCount !== nextProps.selectedCount;
  }
  render() {
    const { selectedCount, total, onChange } = this.props;
    const checked = selectedCount === total;
    return (
      <div className="row middle-xs p-5 top-0 right-0 absolute">
        <span className="mr-10">
          {selectedCount}/{total} Selected
        </span>
        {!this.props.readonly && (
          <CheckboxInline>
            <input type="checkbox" className="checkBox pointer" checked={checked} onChange={() => onChange()} />
            <label className="ml-5 mr-10 pointer" onClick={() => onChange()}>{`${
              checked ? 'Deselect' : 'Select'
            } All`}</label>
          </CheckboxInline>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/vendor/_components/vendor-trade-maintenance/trade-zips/_components/select-count.component.tsx